import { Flex } from '@chakra-ui/react';
import { AltTextMenu } from 'modules/Editor/components/Toolbar/AltTextMenu/AltTextMenu';
import { ToolbarDivider } from 'modules/common/components/Toolbar/ToolbarDivider';
import { Widget } from 'types/widget.types';
import { IconWidgetToolbarMenu } from 'widgets/IconWidget/IconWidgetToolbar';
import { ProgressChartWidgetToolbar } from 'widgets/ProgressChartWidget/ProgressChartWidgetToolbar';
import { LabelTextToolbar } from 'widgets/TextBasedWidgets/LabelTextWidget/LabelTextToolbar';
import { ReplaceButton, useWidget } from 'widgets/sdk';
import { WidgetStore } from 'widgets/store';

import { ComponentWidgetIdKeys, StatChartType, StatChartWidgetData } from '../StatChartWidget.types';
import { ChartSwap } from './ChartSwap';
import { ChartValueInput } from './ChartValueInput';
import { StatChartWidgetToolbarProps } from './StatChartWidgetToolbar.types';
import { ToggleMenu } from './ToggleMenu';
import { TotalItems } from './TotalItems';
import { VerticalSpacingOption } from './VerticalSpaceOption';

export const StatChartWidgetToolbar = ({ selectedWidgetType }: StatChartWidgetToolbarProps) => {
  return (
    <Flex gap='2' align='center' data-testid='statchart-widget-toolbar'>
      <StatChartWidgetToolbarLayout selectedWidgetType={selectedWidgetType} />
    </Flex>
  );
};

const StatChartWidgetToolbarLayout = ({ selectedWidgetType }: StatChartWidgetToolbarProps) => {
  const { widgetId, type, componentWidgetIdMap } = useWidget<StatChartWidgetData>();

  const labelTextWidgetId = componentWidgetIdMap[ComponentWidgetIdKeys.MetricText];
  const iconWidgetId = componentWidgetIdMap[ComponentWidgetIdKeys.IconGrid];
  const chartWidgetId = componentWidgetIdMap[ComponentWidgetIdKeys.Chart];

  if (selectedWidgetType === 'Label') {
    // the label for the statchart icon widget always has a font size option
    const customWidgetData = type === StatChartType.Icon ? ({ hasFontSizeOption: true } as Partial<Widget>) : {};

    return (
      <WidgetStore widgetId={labelTextWidgetId} customWidgetData={customWidgetData}>
        <LabelTextToolbar />
      </WidgetStore>
    );
  }

  if (selectedWidgetType === 'Icon') {
    return (
      <>
        <ReplaceButton />
        <ToolbarDivider />
        <ChartValueInput />
        <ToolbarDivider />
        <TotalItems />
        <ToolbarDivider />
        <ChartSwap />
        <WidgetStore widgetId={iconWidgetId}>
          <IconWidgetToolbarMenu />
        </WidgetStore>
        <ToggleMenu />
        <AltTextMenu widgetId={widgetId} />
      </>
    );
  }

  if (selectedWidgetType === 'Chart') {
    return (
      <>
        <ChartValueInput />
        <ToolbarDivider />
        <ChartSwap />
        {type === StatChartType.ProgressBar && (
          <>
            <WidgetStore widgetId={chartWidgetId}>
              <ProgressChartWidgetToolbar />
            </WidgetStore>
            <VerticalSpacingOption />
            <ToolbarDivider />
          </>
        )}
        {(type === StatChartType.Donut || type === StatChartType.HalfDonut) && (
          <WidgetStore widgetId={chartWidgetId}>
            <ProgressChartWidgetToolbar />
          </WidgetStore>
        )}

        <ToggleMenu />
        <AltTextMenu widgetId={widgetId} />
      </>
    );
  }

  return null;
};
